<template>
  <v-card class="project-details-card">
    <p class="project-details-card__line">
      ID projektu: <b>{{ commercialPrint.id }}</b>
    </p>
    <p
      v-if="commercialPrint.createdAt"
      class="project-details-card__line"
    >
      Data rozpoczęcia: <b>{{ commercialPrint.createdAt | displayDate }}</b>
    </p>
    <p
      v-if="commercialPrint.deadline"
      class="project-details-card__line"
    >
      Termin wykonania: <b>{{ commercialPrint.deadline }}</b>
    </p>
    <p
      v-if="commercialPrint.commercialPrintType"
      class="project-details-card__line"
    >
      Typ projektu: <b>{{ commercialPrint.commercialPrintType }}</b>
    </p>
    <p
      v-if="commercialPrint.discLocation"
      class="project-details-card__line"
    >
      Lokalizacja: <b>{{ commercialPrint.discLocation }}</b>
    </p>
    <p class="project-details-card__line">
      Do druku: <b>{{ commercialPrint.printCoordination ? 'Tak' : 'Nie' }}</b>
    </p>
  </v-card>
</template>

<script>
import AppCopyUrl from '@/components/UI/AppCopyUrl.vue';

export default {
  components: {
    AppCopyUrl,
  },

  props: {
    commercialPrint: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.project-details-card {
  padding: 20px 32px;

  &__title {
    font-size: 15px;
  }

  &__line {
    line-height: 24px;
  }
}
</style>
